module.exports = __webpack_public_path__ + "static/media/SUNPHARMA_F1.30fd15c0.txt";